import { gettext } from '@eventbrite/i18n';

/**  FORM MESSAGES START **/

export const FORM_FIELD_EMAIL_MISMATCHES = gettext(
    "Email address doesn't match. Please try again",
);

export const FORM_FIELD_NAME_REQUIRED = gettext('First name is required');
export const FORM_FIELD_NAME_LENGTH = gettext(
    'First name must be less than 50 characters',
);
export const FORM_FIELD_NAME_SPACES = gettext('First name cannot be spaces');
export const FORM_FIELD_LAST_NAME_REQUIRED = gettext('Last name is required');
export const FORM_FIELD_LAST_NAME_LENGTH = gettext(
    'Last name must be less than 50 characters',
);
export const FORM_FIELD_LAST_NAME_SPACES = gettext(
    'Last name cannot be spaces',
);
export const FORM_FIELD_PASSWORD_LENGTH = gettext(
    'Password must be at least 8 characters',
);
export const FORM_FIELD_PASSWORD_REQUIRED = gettext('Password is required');
export const FORM_FIELD_PASSWORD_KNOWN_WEAK = gettext(
    'Password is highly guessable. Try again.',
);
export const FORM_FIELD_PASSWORD_NOT_COMPLEX_ENOUGH = gettext(
    'Password requires at least one uppercase and one lowercase letter + a number',
);

/**  FORM MESSAGES END **/
